import React, { lazy, Suspense, memo } from 'react'
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import Loading from 'components/shared-components/Loading';
import { lightTheme, darkTheme } from 'configs/ThemeConfig';
import { isMarketerUser } from 'configs/AppConfig';
import { resources } from 'lang';
import useBodyClass from 'utils/hooks/useBodyClass';
import Routes from 'routes'

const AppLayout = lazy(() => import('./AppLayout'));
const AuthLayout = lazy(() => import('./AuthLayout'));
const MarketerLayout = lazy(() => import('./MarketerLayout'));

const Layouts = () => {

	const token = useSelector(state => state.auth.token);
	const user = useSelector(state => state.auth.user);
	const blankLayout = useSelector(state => state.theme.blankLayout);
	const location = useLocation();

	const isPortalRoute = location.pathname.startsWith('/portal');
	const isGroceryRoute = location.pathname === '/grocery' || location.pathname.startsWith('/grocery/');
	const isMarketerRoute = location.pathname.startsWith('/app/marketer');
	const showMarketerShell = isMarketerRoute && token && isMarketerUser(user);

	const Layout = isPortalRoute
		? React.Fragment
		: (isGroceryRoute
			? AuthLayout
			: (showMarketerShell
				? MarketerLayout
				: (token && !blankLayout ? AppLayout : AuthLayout)));

	const locale = useSelector(state => state.theme.locale);

	const direction = useSelector(state => state.theme.direction);

	const currentTheme = useSelector(state => state.theme.currentTheme);

	const currentAppLocale = resources[locale];

	useBodyClass(`dir-${direction}`);
	useBodyClass(`theme-${currentTheme}`);

	const themeConfig = currentTheme === 'light' ? {...lightTheme} : {...darkTheme}

	return (
		<ConfigProvider theme={themeConfig} direction={direction} locale={currentAppLocale.antd}>
			<Suspense fallback={<Loading cover="content"/>}>
				<Layout>
					<Routes />
				</Layout>
			</Suspense>
		</ConfigProvider>
	)
}

export default memo(Layouts)